import {EntityFollowedEvent} from './EntityFollowedEvent';

export class CompetitionFollowed extends EntityFollowedEvent {}
